import { render, staticRenderFns } from "./Rc-Ventas.vue?vue&type=template&id=75c3806a&scoped=true&"
import script from "./Rc-Ventas.vue?vue&type=script&lang=js&"
export * from "./Rc-Ventas.vue?vue&type=script&lang=js&"
import style0 from "./Rc-Ventas.vue?vue&type=style&index=0&id=75c3806a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c3806a",
  null
  
)

export default component.exports